

import React from 'react';
import Badge from '@mui/material/Badge';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

const StatusBadge = ({ content }) => {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT = "commonPortal"
  const getStatusStyles = {
    background: content === 'pass' ? 'linear-gradient(45deg, #4CAF50, #8BC34A)' : 'linear-gradient(45deg, #ff1744, #ff8a80)',

    boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.6)',
    padding: '6px 10px',
    borderRadius: 10,
    textTransform: 'uppercase',
    color: 'white',
    fontWeight:"bold",
  };

  return (
    <Badge  color="default" style={getStatusStyles}>
      <span>{translate(TranslationEnum.common_portal,content)}</span>
    </Badge>
  );
};

export default StatusBadge;
